import { useState } from 'react';
import Markdown from 'markdown-to-jsx';

import Accordion from '~/components/Header/lib/components/accordion';

import Section, { SectionHeading } from '../Section';

import styles from './FAQs.module.css';

export const FAQs = () => {
  const [activeAccordion, setActiveAccordion] = useState('');

  const faqs = [
  {
    heading: 'How do I get access to Oddschecker Unlimited?',
    body: 'You will need to sign-up to oddschecker and be logged in to your oddschecker account. Once you have submitted your payment, all of the features of Oddschecker Unlimited will then be available to you.'
  },
  {
    heading: 'Which ads will I no longer see after subscribing?',
    body: 'You will no longer see any banner adverts or popups while browsing the website. This includes leaderboard and skyscraper ads on the homepage and grid pages and any promotional messages served via pop -up messages. You will still be able to see free bets and sign-up offers on the Free Bets page and associated pages.'
  },
  {
    heading: 'Which extra tips/insights are included in the subscription?',
    body: 'There are multiple tipsters from different sports providing weekly extra content to subscribers, which are: \n- Weekly ante-post view from Steve Ryder – looking ahead to the weekend’s racing in search for value. \n- Weekly early look from Niall Lyons – looking ahead to the following week’s PGA Tour event with course specifics and a run through the field.  \n- Weekend value pick from Mark O’Haire – A value bet from Mark O’Haire backed by the latest data for your weekend football betting.'
  },
  {
    heading: 'Is this a subscription or a one-off payment?',
    body: 'By subscribing you are agreeing to a monthly payment of £19.99, which will be debited from your account each month. You can cancel at anytime. <br><br>If you have subscribed to the annual package your plan will auto renew on the same date you signed up the following year.'
  },
  {
    heading: 'How can I manage my subscription?',
    body: 'Your first port of call will be the ‘My Account’ section of our website, which will provide links to Stripe where you can manage which plan you’re on, change bank details and cancel your subscription.'
  },
  {
    heading: 'Can I still use Oddschecker for free?',
    body: 'Yes, you can still continue to use all of oddschecker that is not restricted by subscription for free and without requiring an account. This includes the Free Bets page.'
  }];


  return (
    <Section className={styles.faq} testId="faqs-section">
			<SectionHeading>
				<h3>FAQs</h3>
			</SectionHeading>
			<div className={styles.accordionWrapper} data-testid="faq-accordion">
				{faqs.map((faq) =>
        <Accordion
          body={
          <div className={styles.accordionBody}>
								<Markdown>{faq.body}</Markdown>
							</div>
          }
          callback={() => setActiveAccordion(faq.heading)}
          className={styles.accordionHeader}
          header={<h4>{faq.heading}</h4>}
          isActive={activeAccordion === faq.heading}
          key={faq.heading}
          testId="faq-row" />

        )}
			</div>
			<a
        className={styles.allFAQsLink}
        href="https://www.oddschecker.com/unlimited-faqs"
        rel="noreferrer"
        target="_blank">

				View all FAQs here
			</a>
		</Section>);

};